import './style.scss';
import Input from './input.js';

export default Input;